import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconViewList = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.5 4.5V7.25H15.5V5C15.5 4.725 15.275 4.5 15 4.5H8.5ZM7 4.5H5C4.725 4.5 4.5 4.725 4.5 5V7.25H7V4.5ZM3 8.75V5C3 3.89688 3.89688 3 5 3H15C16.1031 3 17 3.89688 17 5V15C17 16.1031 16.1031 17 15 17H5C3.89688 17 3 16.1031 3 15V8.75ZM4.5 11.25H7V8.75H4.5V11.25ZM4.5 12.75V15C4.5 15.275 4.725 15.5 5 15.5H7V12.75H4.5ZM8.5 15.5H15C15.275 15.5 15.5 15.275 15.5 15V12.75H8.5V15.5ZM15.5 11.25V8.75H8.5V11.25H15.5Z",
		fill: "currentColor"
	})
});
export default SvgIconViewList;
